module.exports = __webpack_public_path__ + "static/img_9559-2e1bf17d1d55d645acc71265c06601f6.webp";